import { createSlice } from "@reduxjs/toolkit";

const initialState={
    giacenze:[],
    singleGiacenza: {},
    isLoading: false,
    error:null,
    um:[],
    formato:[],
    motivazione:[],
    enumsLoading:{
    um:false,
    formato:false,
    motivazione:false,
    },
    enumsError:{
        um: null,
        formato: null,
        motivazione:null
    }
}

const giacenzeSlice = createSlice({
    name: "giacenze",
    initialState,
    reducers:{
        setGiacenze:(state, action) => {
            state.giacenze = action.payload
        },
        addGiacenze:(state, action) => {
            state.giacenze.push(action.payload)
        },
        addGiacenzeId:(state, action) => {
            state.singleGiacenza = action.payload
        },
        updateGiacenze:(state, action) => {
            const index = state.giacenze.findIndex(
                (item) => item.id === action.payload.id
              );
              if (index !== -1) {
                state.giacenze[index] = action.payload;
              }
            },
        deleteGiacenze:(state, action) => {
            state.giacenze = state.giacenze.filter(
                (item) => item.id!== action.payload
              );
        },
        apiRequestStart:(state) => {
            state.isLoading = true;
            state.error = null
        },
        apiRequestSuccess:(state) => {
            state.isLoading = false
        },
        apiRequestFailure:(state,action) => {
            state.isLoading = false;
            state.error = action.payload
        },
        setUm:(state, action) => {
            state.um = action.payload
        },
        setFormato:(state, action) => {
            state.formato = action.payload
        },
        setMotivazione:(state, action) => {
            state.motivazione = action.payload
        },
        enumRequestStart:(state, action) => {
            state.enumsLoading[action.payload] =true
            state.enumsError[action.payload]=true
        },
        enumRequestSuccess:(state, action) => {
            state.enumRequestStart[action.payload] = false
        },
        enumRequestFailure:(state, action) => {
            const {enumType, error} =action.payload;
            state.enumsLoading[enumType] = false
            state.enumsError[enumType] = error
        }  
    }
});

export const {
    setGiacenze,
    addGiacenze,
    addGiacenzeId,
    updateGiacenze,
    deleteGiacenze,
    apiRequestStart,
    apiRequestFailure,
    apiRequestSuccess,
    setUm,
    setFormato,
    setMotivazione,
    enumRequestStart,
    enumRequestSuccess,
    enumRequestFailure

} = giacenzeSlice.actions

export const selectGiacenze = (state) => state.giacenze?.giacenze;
export const selectSingleGiacenze = (state) => state.giacenze?.singleGiacenza;
export const selectisLoading = (state) => state.giacenze?.isLoading;
export const selectError = (state) => state.giacenze?.error;
export const selectUm = (state) => state.giacenze?.um
export const selectMotivazione = (state) => state.giacenze?.motivazione
export const selectFormato = (state) => state.giacenze?.formato

export default giacenzeSlice.reducer;